/**
 * getAPI funtion
 * @returns : API url based on host url
 *
 * Parse the host url and find out backend api url
 */




const getBaseAPIURL = function () {
    var port = '',
        subPath = '',
        protocol = window.location.protocol;
    if (window.location.hostname === 'localhost') {
        port = ':59971';
        protocol = 'https:';
    } else {
        subPath = '/reportweb';
    }
    return protocol + '//' + window.location.hostname + port + subPath;
}



export const BaseURL = getBaseAPIURL();
export const GET_SETTING_SUB_PATH = '/AppSettings/GetSettingByName?propertyName=';
export const RPTR_BASE_PROP_NAME = 'REPORTER_BASE_URL';
export const SERVICE_UNAVAILABLE_ERROR_MSG = process.env.VUE_APP_SERVICE_MESSAGE;
export const SERVICE_NO_DATA_MSG = process.env.VUE_APP_NO_DATA_MESSAGE;

export const RECOVERY_ID_MAX = parseInt(process.env.VUE_APP_RECOVERY_ID_MAX);

